import icons from './natds-icons.json';
const iconNames = Object.keys(icons);
export { icons, iconNames, };
//# sourceMappingURL=index.js.map